import React, { useState } from "react";
import { FaRegHeart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Buttons } from "../Buttons";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist } from "../../redux/store/wishlist";
import { addToCart } from "../../redux/store/cartSlice";
import CartDrawer from "../CartDrawer";

function ProductCard({ products }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cartDrawer, setCartDrawer] = useState(false);
  const wishlistItems = useSelector((state) => state.wishlist.wishlistItems);

  const handleProduct = (id) => {
    navigate(`/product_description/${id}`);
  };

  const handleWishlist = () => {
    const exists = wishlistItems.find((item) => item.id === products.id);

    if (exists) {
      toast.error("Product already in wishlist");
    } else {
      dispatch(addToWishlist(products));
      toast.success("Product added to wishlist");
    }
  };

  function truncateDescription(htmlString = "", wordLimit = 10) {
    const text = htmlString.replace(/<[^>]*>/g, "");
    const words = text.split(" ").slice(0, wordLimit).join(" ");
    return words + (text.split(" ").length > wordLimit ? "..." : "");
  }
  const handleAddtoCart = (product) => {
    dispatch(addToCart(product));
    toast.success("Add to Cart Successfully");
    setCartDrawer(true);
  };
  return (
    <div className="relative w-[200px] sm:w-[250px] md:w-[280px] lg:w-[300px] flex-shrink-0 ">
      <div className="border border-gray-300 rounded-md bg-white h-full flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex flex-col items-center gap-2 p-3">
          <h1 className="text-[16px] md:text-[16px] font-bold text-center truncate">
            {products.title}
          </h1>
          <p className="text-[13px] md:text-[14px] text-center text-gray-600">
            {truncateDescription(products.vendor, 10)}
          </p>
        </div>

        {/* Image */}
        <div className="flex justify-center items-center px-3">
          <img
            src={products.image}
            alt=""
            className="w-full h-[160px] sm:h-[200px] md:h-[220px] object-contain rounded-xl cursor-pointer"
            onClick={() => handleProduct(products.id)}
          />
        </div>

        {/* Bottom */}
        <div className="flex-1 flex flex-col justify-between p-3 gap-3">
          <div className="flex gap-2 items-center justify-center">
            <p className="text-[18px] md:text-[20px] font-semibold">
              $ {products?.variants?.[0]?.price}
            </p>
            {products?.variants?.[0]?.compare_at_price && (
              <p className="text-[16px] text-gray-400 line-through">
                $ {products?.variants?.[0]?.compare_at_price}
              </p>
            )}
          </div>

          <Buttons
            title={"Add to cart"}
            handleClick={() => handleAddtoCart(products)}
          />
        </div>
      </div>

      {/* Wishlist Button */}
      {/* <button
        onClick={handleWishlist}
        className="absolute top-3 right-3 w-8 h-8 rounded-full bg-green-200 flex items-center justify-center
        opacity-0 translate-y-[-10px]
        group-hover:opacity-100 group-hover:translate-y-0
        transition-all duration-300 hover:bg-green-300 hover:scale-110"
      >
        <FaRegHeart color="green" size={16} />
      </button> */}
      {cartDrawer && (
        //  drawer
        <CartDrawer onClose={() => setCartDrawer(false)} />
      )}
    </div>
  );
}

export default ProductCard;
